import React, { Suspense, useState, useEffect } from 'react';
import { renderRoutes } from 'react-router-config';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { LinearProgress, useMediaQuery } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles'
import { Redirect } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
  appRefreshedSelector,
  loggedInSelector,
  appLoadingSelector,
} from 'redux/selectors';

import { TopBar, NavBar } from './components';
import { refreshApp } from 'redux/actions/app';
import Loader from 'components/Loader';
import { drawerWidth, drawerCloseWidth } from './components/NavBar'
import { topbar_height } from './components/TopBar'
import { ConversationProvider } from 'pages/Messages/provider'
import { FabButton } from 'components'
import AnounceModal from 'components/AnounceModal';
import { setUrgentModal } from 'redux/actions/language';

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden'
  },

  container: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden'
  },
  content: {
    overflow: 'hidden',
    flex: '1 1 auto',
    // default to full width on small screens
    // marginLeft: 10,
    // marginRight: 10,
    // Add consistent top margin for app bar height across all screen sizes
    paddingTop: topbar_height,
    transition: 'all .5s ease',
    // On small and up screens push content by drawer width (or collapsed width)
    [theme.breakpoints.up('sm')]: {
      marginLeft: props => props.openDrawer ? drawerWidth : drawerCloseWidth,
    },
    [theme.breakpoints.down('xs')]: {
      // keep full width on xs, add a little extra top padding for spacing
      paddingTop: topbar_height
    }
  },
}));

const HomeLayout = props => {
  const { route, location } = props;
  const [openDrawer, setOpenDrawer] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  
  const classes = useStyles({ openDrawer });
  const dispatch = useDispatch();

  const isLoggedIn = useSelector(loggedInSelector);
  const isRefreshed = useSelector(appRefreshedSelector);
  const isLoading = useSelector(appLoadingSelector);
  const { urgetModal } = useSelector(state => state.language);

  useEffect(() => {
    if (isLoggedIn && !urgetModal) {
      setOpenModal(true);
      dispatch(setUrgentModal());
    }
  }, [isLoggedIn, urgetModal]);

  if (!isLoggedIn) {
    return <Redirect to="/auth/login" />;
  }

  if (!isRefreshed) {
    dispatch(refreshApp());
    return <Loader />;
  }

  return (
    <ConversationProvider>
      <div className={classes.root}>
        <TopBar openDrawer={openDrawer} setOpenDrawer={setOpenDrawer} location={location} />
        <div className={classes.container}>
          <NavBar openDrawer={openDrawer} setOpenDrawer={setOpenDrawer} />
          <main className={classes.content}>
            <Suspense fallback={<LinearProgress />}>
              {renderRoutes(route.routes)}
            </Suspense>
          </main>
          {isLoading && <Loader />}
          <FabButton />
        </div>
      </div>
      <AnounceModal
        open={openModal}
        closeModal={() => setOpenModal(false)}
      />
    </ConversationProvider>
  );
};

HomeLayout.propTypes = {
  route: PropTypes.object,
  location: PropTypes.any
};

export default HomeLayout;
